export const URI_WORKSHOP_TEMPLATE_CATEGORY = 'workshop/template/category';
